import styled from 'styled-components';
import InlineRadio from 'gatsby-theme-core/src/components/form-elements/inline-radio/index';
import Radio from 'gatsby-theme-core/src/components/form-elements/radio/index';

export default styled(InlineRadio)`
  margin-bottom: 1.5rem;
  margin-right: 1rem;

  ${Radio} {
    margin-right: .75rem;
  }
`;
